import {useDeviceSize} from './../theme/helpers';
import {useDialog} from '../components/modal/dialog';
import {DeviceSize} from '../theme/helpers';
import {Dispatch} from 'redux';

import {useAppDispatch} from '../../redux';
import React from 'react';
import {CounterpartyLinkedProfile} from './useAccountLinkerHook/Types';

export const useAccountLinkConfirmationDialog = ({
  confirmationMessage,
  confirmedAction,
  currentAccountSetter,
  id,
}: {
  confirmationMessage: string;
  confirmedAction: (id: string, dispatch: Dispatch) => void;
  currentAccountSetter?: React.Dispatch<React.SetStateAction<CounterpartyLinkedProfile | undefined>>;
  id: string;
}): (() => Promise<void>) => {
  const dialog = useDialog();
  const deviceSize = useDeviceSize();
  const dispatch = useAppDispatch();

  return async () => {
    dialog.showDialog({
      message: confirmationMessage,
      actions: [
        {
          title: 'Да',
          type: 'primary',
          closeModal: true,
          onPress: () => {
            confirmedAction(id, dispatch);
            if (currentAccountSetter) currentAccountSetter(undefined);
          },
        },
        {
          title: 'Нет',
          type: 'transparent',
          closeModal: true,
        },
      ],
      messageStyle: deviceSize === DeviceSize.desktop ? {marginBottom: 42} : {marginBottom: 30},
    });
  };
};
